import { FC } from "react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "~/components/ui/tooltip";
import { UserAvatar } from "~/components/ui/user-avatar";
import { PresentUser } from "~/features/case/hooks/useCasePresence";

export const PresenceAvatars: FC<{ users: PresentUser[] }> = ({ users }) => {
  if (!users.length) return null;

  const top = users.slice(0, 3);
  return (
    <TooltipProvider>
      <div className="flex -space-x-1">
        {top.map((u) => (
          <Tooltip key={u.id}>
            <TooltipTrigger asChild>
              <UserAvatar
                name={u.name}
                size="sm"
                className="border-2 border-background"
              />
            </TooltipTrigger>
            <TooltipContent>
              <p>{u.name}</p>
            </TooltipContent>
          </Tooltip>
        ))}
        {users.length > 3 && (
          <Tooltip>
            <TooltipTrigger asChild>
              <div className="flex h-5 w-5 items-center justify-center rounded-full bg-muted-foreground text-[9px] text-background border-2 border-background">
                +{users.length - 3}
              </div>
            </TooltipTrigger>
            <TooltipContent>
              <p>{users.length - 3} more users</p>
            </TooltipContent>
          </Tooltip>
        )}
      </div>
    </TooltipProvider>
  );
};
